import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LnArrowBackSvgIconComponent } from '@components/svg-icons/ln-arrow-back-svg-icon/ln-arrow-back-svg-icon.component';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { MenuActions } from '../../shared/states/menu_actions';
import { AllSpecialCreatedProductsComponent } from '@components/all-special-created-products/all-special-created-products.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-all-special-products',
  imports: [LnArrowBackSvgIconComponent, LnPagesArmorComponent, AllSpecialCreatedProductsComponent, TranslocoPipe],
  templateUrl: './all-special-products.component.html',
  styleUrl: './all-special-products.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllSpecialProductsComponent {
  private menuActions = inject(MenuActions);
  goHome() {
    this.menuActions.goHome();
  }
}
